function getDfeKeyModel(key: string) {
    return key.substring(20, 22);
}

export default getDfeKeyModel;
